var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "0a549b3778f15157b17bb2478bd61f9ffbd533ce"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["marketing-js@when-i-work"] = {
  id: "0a549b3778f15157b17bb2478bd61f9ffbd533ce"
};